import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { GlobalContext } from '../lib/GlobalVar';

// Faixa fixa do modo "ver como" (lib/verComo.js): diz com o acesso de quem a TI esta vendo o
// Central e leva de volta para a conta dela. So aparece com o modo ativo.
export default function VerComoBanner() {
    const { user, realUser, sairVerComo } = useContext(GlobalContext);
    const navigate = useNavigate();
    if (!realUser || !user) return null;
    const papel = [user.setor, user.cargo].filter(Boolean).join(' · ');
    return (
        <div role="status" style={{
            position: 'sticky', top: 0, zIndex: 60, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            gap: 12, flexWrap: 'wrap', padding: '8px 16px', background: '#B45309', color: '#fff', fontSize: 13,
            boxShadow: '0 1px 4px rgba(0,0,0,.15)',
        }}>
            <span>
                Você está vendo o Central como <b>{user.nome}</b>{papel ? <> ({papel})</> : null}.
                {' '}Ações que gravam estão bloqueadas.
            </span>
            <button type="button" className="btn sm"
                style={{ background: '#fff', color: '#7C2D12', borderColor: '#fff' }}
                onClick={() => { sairVerComo(); navigate('/TI/Logins'); }}>
                Voltar para a minha conta ({realUser.nome})
            </button>
        </div>
    );
}
